import PropTypes from "prop-types";
import React from "react";
import { SwatchesPicker } from "react-color";
import "./ColorField.css"; // #region HOOK

/**
 * Représente un sélecteur de couleur sous forme de palette
 * @class
 * @category Fields
 * @param {Fields.ColorField.propTypes} props Les propriétés du champ
 */

function ColorField(props) {
  // Récupération des props
  var height = props.height,
      icon = props.icon,
      keepSpaceIcon = props.keepSpaceIcon,
      onChange = props.onChange,
      textColor = props.textColor,
      tooltip = props.tooltip,
      value = props.value,
      width = props.width;
  return /*#__PURE__*/React.createElement("div", {
    className: "ColorField-Container",
    style: {
      width: width
    }
  }, (icon || keepSpaceIcon) && /*#__PURE__*/React.createElement("div", {
    className: "ColorField-IconContainer"
  }, icon && /*#__PURE__*/React.createElement("i", {
    className: "ColorField-Icon fas fa-" + icon,
    style: {
      color: textColor
    },
    "data-tip": tooltip,
    "data-for": "DefaultTooltip"
  })), /*#__PURE__*/React.createElement(SwatchesPicker, {
    color: value ? value : "#fff",
    onChangeComplete: onChange,
    width: "100%",
    height: height
  }));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link ColorField}
 * @typedef {Object} ColorField.propTypes
 * @property {string} [value=null] La couleur sélectionnée
 * @property {function} onChange La fonction de callback de l'évènement onChange
 * @property {string} tooltip Le texte du champ
 * @property {number} [height=150] La hauteur du composant
 * @property {string} [textColor=#000] La couleur du texte
 * @property {string} [icon=palette] L'icône du composant
 * @property {boolean} [keepSpaceIcon=false] true pour maintenir un écart vide si pas d'icône lorsqu'on empile des champs
 */


ColorField.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  tooltip: PropTypes.string.isRequired,
  height: PropTypes.number,
  textColor: PropTypes.string,
  icon: PropTypes.string,
  keepSpaceIcon: PropTypes.bool
} : {};
/*
  Valeurs par défaut des propriétés
*/

ColorField.defaultProps = {
  value: null,
  height: 150,
  textColor: "#000",
  icon: "palette",
  keepSpaceIcon: false
}; // #endregion

export { ColorField };